import React, { useState, useRef, useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const menuItems = [
  { name: 'لوحة التحكم',     path: '/dashboard',           icon: 'bi-speedometer2'  },
  { name: 'البث المباشر',    path: '/live',                icon: 'bi-broadcast'     },
  { name: 'الفيديوهات',      path: '/videos',              icon: 'bi-camera-video'  },
  { name: 'الصوتيات',        path: '/audios',              icon: 'bi-mic-fill'      },
  { name: 'الأسئلة والأجوبة',path: '/qna',                 icon: 'bi-chat-dots'     },
  { name: 'التصنيفات',       path: '/categories',          icon: 'bi-folder'        },
  { name: 'الوسوم',          path: '/collections/tags',    icon: 'bi-tags'          },
  { name: 'القراء',          path: '/readers',             icon: 'bi-person-circle' },
  { name: 'الوسائط',         path: '/collections/upload/files', icon: 'bi-image'   },
];

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleNav = (path) => {
    navigate(path);
    onClose();
  };

  const isActive = (path) =>
    path === '/dashboard'
      ? location.pathname === path
      : location.pathname.startsWith(path);

  return (
    <div className={`sidebar-container d-flex flex-column flex-shrink-0 p-3 bg-dark text-white${isOpen ? ' sidebar-open' : ''}`}>
      {/* Mobile close button */}
      <button
        type="button"
        className="btn-close btn-close-white d-md-none align-self-end mb-2"
        aria-label="إغلاق"
        onClick={onClose}
      />

      {/* Logo/Brand */}
      <a
        href="/dashboard"
        className="d-flex align-items-center mb-3 text-white text-decoration-none border-bottom pb-3"
        onClick={(e) => { e.preventDefault(); handleNav('/dashboard'); }}
      >
        <i className="bi bi-tv fs-4 ms-2"></i>
        <span className="fs-5 fw-bold">الموسوي تي في</span>
      </a>

      <hr />

      {/* Navigation Menu */}
      <Nav className="nav nav-pills flex-column mb-auto">
        {menuItems.map((item) => (
          <Nav.Item key={item.path}>
            <Nav.Link
              className={`nav-link text-white d-flex align-items-center${isActive(item.path) ? ' active' : ''}`}
              onClick={() => handleNav(item.path)}
              style={{
                cursor: 'pointer',
                backgroundColor: isActive(item.path) ? '#0d6efd' : 'transparent',
              }}
            >
              <i className={`${item.icon} ms-2`} style={{ fontSize: '1.2rem' }}></i>
              <span>{item.name}</span>
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      <hr />

      {/* User Profile Section */}
      <div ref={userMenuRef} style={{ position: 'relative' }}>
        <button
          type="button"
          className="d-flex align-items-center gap-2 text-white text-decoration-none btn btn-link p-0 w-100"
          onClick={() => setUserMenuOpen((v) => !v)}
        >
          <i className="bi bi-person-circle fs-4"></i>
          <span className="text-truncate flex-grow-1 text-start">
            {user?.username || user?.email || 'المستخدم'}
          </span>
          <i className={`bi bi-chevron-${userMenuOpen ? 'up' : 'down'}`} style={{ fontSize: '0.75rem' }}></i>
        </button>

        {userMenuOpen && (
          <ul
            className="list-unstyled mb-0 mt-2 py-1 rounded"
            style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)' }}
          >
            <li>
              <button
                type="button"
                className="btn btn-link text-white text-decoration-none w-100 text-end px-3 py-2"
                style={{ fontSize: '0.9rem' }}
                onClick={handleLogout}
              >
                <i className="bi bi-box-arrow-left ms-2"></i>
                تسجيل الخروج
              </button>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
